import createIcon from '../../createIcon';

/**
 * @component @name PermMedia
 * @description Google Material SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNMiA2SDBWMTFIMC4wMUwwIDIwQzAgMjEuMSAwLjkgMjIgMiAyMkgyMFYyMEgyVjZaTTIyIDRIMTRMMTIgMkg2QzQuOSAyIDQuMDEgMi45IDQuMDEgNEw0IDE2QzQgMTcuMSA0LjkgMTggNiAxOEgyMkMyMy4xIDE4IDI0IDE3LjEgMjQgMTZWNkMyNCA0LjkgMjMuMSA0IDIyIDRaTTcgMTVMMTEuNSA5TDE1IDEzLjUxTDE3LjUgMTAuNUwyMSAxNUg3WiIgZmlsbD0iYmxhY2siLz4KPC9zdmc+Cg==)
 *
 * @param {Object} props - Google Material icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const PermMedia = createIcon('PermMedia', [
  [
    'path',
    {
      d: 'M2 6H0V11H0.01L0 20C0 21.1 0.9 22 2 22H20V20H2V6ZM22 4H14L12 2H6C4.9 2 4.01 2.9 4.01 4L4 16C4 17.1 4.9 18 6 18H22C23.1 18 24 17.1 24 16V6C24 4.9 23.1 4 22 4ZM7 15L11.5 9L15 13.51L17.5 10.5L21 15H7Z',
      key: '1slqrj',
    },
  ],
]);

export default PermMedia;
